import { useEffect, useState } from 'react';

import { IEquipment } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/Equipment.dto';

import { isClientSide } from '@r1-frontend/shared/helpers/ssr';

import AdaptiveNukaCarousel from '~/src/components/AdaptiveNukaCarousel';
import DeviceGridItem from '~/src/components/Equipment/internet/DeviceGridItem';

import { NoSsrWrapper } from './styled';

interface IRoutersProps {
    routers: IEquipment[],
    cellSpacing?: number,
    isDecoder?: boolean,
    baseRoute?: string,
}

const Routers = ({ routers, cellSpacing, isDecoder, baseRoute }: IRoutersProps): JSX.Element => {
    const [onClientSide, setOnClientSide] = useState(false);

    useEffect(() => {
        setOnClientSide(isClientSide());
    }, []);

    const getRoutersCards = () => {
        return (
            routers.map(router => (
                <DeviceGridItem
                    key={router.id}
                    item={router}
                    baseRoute={baseRoute || `${isDecoder ? '/movix-new' : '/internet'}/equipment`}
                    isCharacteristics={true}
                />
            ))
        );
    };

    return (onClientSide
        ? <AdaptiveNukaCarousel
            withoutDots
            cellSpacing={cellSpacing || 26}
            slidesToScroll={'auto'}
            desktopSlideWidth={'320px'}
            data-test='routers-carousel'
        >
            {getRoutersCards()}
        </AdaptiveNukaCarousel>
        : <NoSsrWrapper>
            {getRoutersCards()}
        </NoSsrWrapper>
    );
};

export default Routers;
